<template>
    <div class="MemberArea MemberArea--create">
        <div class="container">
            <h1 class="MemberArea__title">Réinitialisez votre mot de passe</h1>
            <form @submit="handleSubmit" class="FormMaterial m-t-30">
                <div class="row">
                    <div class="col-md-6">
                        <InputClassic @input="value => handleChange('password', value)"
                                      label="Nouveau mot de passe" v-model="data.password" type="password"
                                      :error="errors.password"/>
                    </div>
                    <div class="col-md-6">
                        <InputClassic @input="value => handleChange('passwordConfirmation', value)"
                                      label="Confirmation" v-model="data.passwordConfirmation"
                                      type="password" :error="errors.passwordConfirmation"/>
                    </div>
                </div>
                <button :disabled="loading" class="Btn Btn--stroked Btn--block m-t-15" @click.prevent="handleSubmit"
                        type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Sauvegarder</span>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    import Rules from '../validator/rules';
    import validate from "../validator/validator";
    import {isEmpty} from "../utils";
    import InputClassic from "./InputClassic";
    import Api from "../services/Api";
    import ModalBus from "../eventBus";

    export default {
        props: ['userId', 'token'],
        components: {InputClassic},
        data: function () {
            return {
                data: {
                    password: null,
                    passwordConfirmation: null
                },
                loading: false,
                errors: {}
            }
        },
        methods: {
            handleChange: function (name) {
                delete this.errors[name];
            },
            handleSubmit: async function () {
                this.loading = true;
                try {
                    let {password} = this.data,
                        errors = validate(this.data, {
                            password: [Rules.required(), Rules.minLength(6)],
                            passwordConfirmation: [Rules.same('password', 'Les mots de passes ne sont pas identiques.')]
                        });

                    if (!isEmpty(errors)) {
                        this.errors = errors;
                        this.loading = false;
                        return;
                    }

                    await Api.post('/auth/password/reset', {
                        user_id: this.userId,
                        token: this.token,
                        new_password: password
                    });

                    ModalBus.$on('closed', () => {
                        window.location.href = window.loginUrl;
                    });

                    ModalBus.alertSuccess(
                        'Mot de passe modifié !',
                        'Votre mot de passe a bien été modifié, vous pouvez dès à présent vous connecter avec ce dernier.'
                    );
                } catch (err) {
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                        this.loading = false;
                    } else {
                        ModalBus.processingError();
                    }
                }

                this.loading = false;
            }
        }
    }
</script>
